import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 24px;
  margin: 0;
`;


export const Header = styled.div`
  /* display: flex; */
  /* align-items: baseline; */
  /* position: fixed; */
  /* top: 51px; */
  /* left: 220px; */
  /* width: calc(100% - 220px); */
  background: #efefef;
  padding: 8px 16px;
  margin: 0;
  z-index: 2;
  min-height: 50px;
  &.justify {
    justify-content: space-between;
  }
`;
